import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { UserSettingsQuery } from "@timeghost/web-api";

type WorkinghoursTypeInput = {
	type: "work" | "absence" | "pause" | { name: string; id?: string };
	typeId?: string;
	name?: string;
};

@Pipe({
	name: "workinghoursType",
})
export class WorkinghoursTypeResolverPipe implements PipeTransform {
	constructor(
		private userSettingsQuery: UserSettingsQuery,
		private translate: TranslateService
	) {}

	transform(_entity: WorkinghoursTypeInput): string | null {
		if (!_entity) return null;

		const userSettings = this.userSettingsQuery.getValue();
		const absenceSubcategorys = userSettings.workspace["workinghours"]?.["absenceSubcategories"];

		const rawType = _entity.type;
		const typeName = typeof rawType === "string" ? rawType : rawType?.name;
		const typeId = _entity.typeId ?? (typeof rawType === "object" && rawType ? rawType.id : undefined);

		if (!typeId || !absenceSubcategorys?.length) {
			return this.translate.instant("comego.types." + typeName);
		}
		if (typeName === "absence" && typeId) {
			const absenceSubcategory = absenceSubcategorys.find((x: any) => x.id === typeId);
			return this.translate.instant(absenceSubcategory?.title ?? "comego.types.absence");
		}
		return (
			absenceSubcategorys?.find((x: any) => x.id === typeId)?.title ??
			this.translate.instant("comego.types." + typeName)
		);
	}
}
